import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    CcReviewComplianceProps,

    LoadCcLibraryItemById,
    LoadCcReviewComplianceItemState,
    LoadCcReviewComplianceHistory,
    LoadCcReviewComplianceTempAnswers,
    LoadCcReviewComplianceTempAnswerVersions,

    setCcReviewComplianceItemDetails,
    setCcReviewComplianceItemState,
    setCcReviewComplianceItemHistory,
    setCcReviewComplianceTempAnswers,
    setCcReviewComplianceTempAnswerVersions,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Details from "./details"
import History from "./history"
import AnswerForm from "./form"

interface ReviewComplianceAnswerProps extends CcReviewComplianceProps {}

const ReviewComplianceAnswer = ({
    setId,
    revisionId,
    complianceItemId,
}: ReviewComplianceAnswerProps) => {
    const item = useSelector((state: StoreType) => state.ccReviewCompliance.itemDetails)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        Promise.all([
            LoadCcLibraryItemById(complianceItemId, setId).then((res) => {
                dispatch(setCcReviewComplianceItemDetails(res))
            }),
            LoadCcReviewComplianceItemState(complianceItemId, revisionId).then((res) => {
                dispatch(setCcReviewComplianceItemState(res))
            }),
            LoadCcReviewComplianceHistory(complianceItemId, revisionId).then((res) => {
                dispatch(setCcReviewComplianceItemHistory(res))
            }),
            LoadCcReviewComplianceTempAnswers(complianceItemId, revisionId)
            .then((res) => {
                dispatch(setCcReviewComplianceTempAnswers(res))
            }),
            LoadCcReviewComplianceTempAnswerVersions(complianceItemId, revisionId)
            .then((res) => {
                dispatch(setCcReviewComplianceTempAnswerVersions(res))
            }),
        ]).then(() => {
            setLoadState(IDLE)
        })
    }, [])

    if (!item) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editAnswer}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <Details />
                <History />
                <AnswerForm />
            </PageContent>
        </Container>
    )
}
export default ReviewComplianceAnswer
